<template>
  <font-awesome-icon
    icon="file-export"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileExport } from '@fortawesome/free-solid-svg-icons'

library.add(faFileExport)

export default {
  name: 'CoozzyFileExportIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-grey-dark;
  }
</style>
